// Experiment 3 : Homepage using React.js
import React from 'react'
import { Link } from 'react-router-dom'

export default function HomePage() {
  return (
    <div className="container">
      <h1>Welcome to Bloomberg Terminal</h1>
      <p>A simple website to see stock market data, made for my Advanced Web Technology lab.</p>

      <h3>Today's Market</h3>
      <table>
        <thead>
          <tr><th>Stock</th><th>Price (Rs)</th></tr>
        </thead>
        <tbody>
          <tr><td>RELIANCE</td><td>2948</td></tr>
          <tr><td>TCS</td><td>4230</td></tr>
          <tr><td>INFY</td><td>1645</td></tr>
        </tbody>
      </table>

      <p>
        <a href="/form/">Create an account</a> or <Link to="/login">Login</Link>
      </p>
      <p>
        Want full access? <a href="/form/payment.html">Buy a plan</a>
      </p>
    </div>
  )
}
